import React, { useContext, useState } from "react";
import { Button, Table, Confirm } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import UnifyJobStore from "../../../app/stores/unifyjobsStore";

const UnifyJobList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [unifyjobId, setUnifyJobId] = useState("");
  const unifyjobsStore = useContext(UnifyJobStore);
  const {
    unifyjobnamesByDate: unifyjobnamesByDate,
    deleteUnifyJob: deleteUnifyJob,
    submitting,
    target,
  } = unifyjobsStore;

  var totalHours = 0;

  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
          <Table.HeaderCell>Work Order ID</Table.HeaderCell>
          <Table.HeaderCell>Technician</Table.HeaderCell>
          <Table.HeaderCell>Start Date</Table.HeaderCell>
          <Table.HeaderCell>Hours</Table.HeaderCell>
          <Table.HeaderCell>SOR ID</Table.HeaderCell>
          <Table.HeaderCell>Work Order Lines Description</Table.HeaderCell>
          <Table.HeaderCell>Comments</Table.HeaderCell>
          <Table.HeaderCell width={1}>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {unifyjobnamesByDate.map((unifyjob) => {
          totalHours = totalHours + unifyjob.hours;
          return (
            <Table.Row key={unifyjob.id}>
              <Table.Cell>{unifyjob.financialYear}</Table.Cell>
              <Table.Cell>{unifyjob.payRun}</Table.Cell>
              <Table.Cell>{unifyjob.workOrderNumber}</Table.Cell>
              <Table.Cell>{unifyjob.tech}</Table.Cell>
              <Table.Cell>
                {unifyjob.startDate &&
                  unifyjob.startDate.substr(8, 2) +
                    "/" +
                    unifyjob.startDate.substr(5, 2) +
                    "/" +
                    unifyjob.startDate.substr(0, 4)}
              </Table.Cell>
              <Table.Cell>{unifyjob.hours}</Table.Cell>
              <Table.Cell>{unifyjob.sorId}</Table.Cell>
              <Table.Cell>{unifyjob.description}</Table.Cell>
              <Table.Cell>{unifyjob.comment}</Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                  <Button
                    as={Link}
                    to={`/financemanagement/unifyjob-edit/${unifyjob.id}`}
                    size="mini"
                    icon="edit"
                    color="blue"
                    title="Edit"
                  />
                  <Button
                    name={unifyjob.id}
                    size="mini"
                    loading={target === unifyjob.id && submitting}
                    onClick={() => {
                      setOpen(true);
                      setUnifyJobId(unifyjob.id);
                    }}
                    icon="delete"
                    color="red"
                    title="Delete"
                  />
                  <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteUnifyJob(unifyjobId);
                      setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
      <Table.Footer>
        {/* <Pagination defaultActivePage={5} totalPages={10} /> */}
        <Table.Row>
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell>{totalHours.toFixed(3)}</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default observer(UnifyJobList);
